import { render, staticRenderFns } from "./PostEditImmo.vue?vue&type=template&id=82f9e2e6&"
import script from "./PostEditImmo.vue?vue&type=script&lang=js&"
export * from "./PostEditImmo.vue?vue&type=script&lang=js&"
import style0 from "./PostEditImmo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports